/**
 * SN Apparel — Theme JS (Luxury Edition v3)
 * Handles: nav scroll, mobile drawer, filter tabs, reveal animations,
 *          back-to-top, product page (variant select, qty, gallery, personalisation),
 *          cart AJAX (qty update, remove), active nav link
 */
(function () {
  'use strict';

  /* ─── UTILITIES ─── */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }

  /* ─── DOM READY ─── */
  document.addEventListener('DOMContentLoaded', function () {
    initNav();
    initDrawer();
    initFilter();
    initReveal();
    initBackToTop();
    initProductPage();
    initCartPage();
    initPersonalisation();
    setActiveNavLink();
    initGalleryThumbs();
  });

  /* ═══════════════════════════════════════
     NAV — sticky scroll state
  ═══════════════════════════════════════ */
  function initNav() {
    var nav = $('.sn-nav');
    if (!nav) return;
    var threshold = 60;
    function update() {
      if (window.scrollY > threshold) {
        nav.classList.add('scrolled');
      } else {
        nav.classList.remove('scrolled');
      }
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  /* ═══════════════════════════════════════
     MOBILE DRAWER
  ═══════════════════════════════════════ */
  function initDrawer() {
    var burger   = $('#sn-burger');
    var drawer   = $('#sn-drawer');
    var closeBtn = $('#sn-drawer-close');
    var overlay  = $('#sn-overlay');
    if (!burger || !drawer) return;

    function openDrawer() {
      drawer.classList.add('open');
      if (overlay) overlay.classList.add('active');
      burger.classList.add('open');
      burger.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var firstLink = drawer.querySelector('a, button');
      if (firstLink) firstLink.focus();
    }

    function closeDrawer() {
      drawer.classList.remove('open');
      if (overlay) overlay.classList.remove('active');
      burger.classList.remove('open');
      burger.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      burger.focus();
    }

    on(burger, 'click', openDrawer);
    on(closeBtn, 'click', closeDrawer);
    on(overlay, 'click', closeDrawer);

    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) closeDrawer();
    });
  }

  /* ═══════════════════════════════════════
     FILTER TABS (homepage)
  ═══════════════════════════════════════ */
  function initFilter() {
    var btns = $$('.sn-filter__btn');
    if (!btns.length) return;

    // The category strip now uses real links so every option works even when
    // JavaScript is unavailable. The legacy filter remains for button-based
    // sections that may be added through the theme editor.
    if (btns[0].tagName === 'A') return;

    btns.forEach(function (btn) {
      on(btn, 'click', function () {
        var filter = btn.dataset.filter;

        btns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');

        // Show/hide product cards by data-cat
        var cards = $$('.sn-product-card[data-cat]');
        cards.forEach(function (card) {
          if (filter === 'all' || card.dataset.cat === filter) {
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        });

        // Show/hide collection row sections
        var colls = $$('.sn-coll');
        colls.forEach(function (coll) {
          if (filter === 'all') {
            coll.style.display = '';
            return;
          }
          var visibleCards = coll.querySelectorAll('.sn-product-card[data-cat="' + filter + '"]');
          coll.style.display = visibleCards.length ? '' : 'none';
        });
      });
    });
  }

  /* ═══════════════════════════════════════
     SCROLL REVEAL
  ═══════════════════════════════════════ */
  function initReveal() {
    var els = $$('.sn-reveal');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { observer.observe(el); });
  }

  /* ═══════════════════════════════════════
     BACK TO TOP
  ═══════════════════════════════════════ */
  function initBackToTop() {
    var btn = $('#sn-btt');
    if (!btn) return;

    window.addEventListener('scroll', function () {
      btn.classList.toggle('visible', window.scrollY > 600);
    }, { passive: true });

    on(btn, 'click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ═══════════════════════════════════════
     ACTIVE NAV LINK
  ═══════════════════════════════════════ */
  function setActiveNavLink() {
    var path = window.location.pathname;
    $$('.sn-nav__link').forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href) return;
      if (href === '/' && path === '/') {
        link.classList.add('active');
      } else if (href !== '/' && path.startsWith(href)) {
        link.classList.add('active');
      }
    });
  }

  /* ═══════════════════════════════════════
     PRODUCT PAGE
  ═══════════════════════════════════════ */
  function initProductPage() {
    var form = $('#sn-product-form');
    if (!form) return;

    /* Quantity controls */
    var qtyInput = $('#sn-qty');
    var qtyMinus = $('#sn-qty-minus');
    var qtyPlus  = $('#sn-qty-plus');

    on(qtyMinus, 'click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      if (val > 1) qtyInput.value = val - 1;
    });
    on(qtyPlus, 'click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = val + 1;
    });

    /* Variant option pills */
    $$('.sn-option-pill').forEach(function (pill) {
      var radio = pill.querySelector('input[type="radio"]');
      if (!radio) return;
      on(pill, 'click', function () {
        var name = radio.name;
        $$('.sn-option-pill input[name="' + name + '"]').forEach(function (r) {
          r.closest('.sn-option-pill').classList.remove('active');
        });
        pill.classList.add('active');
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    /* Keep Shopify variant ID, price and availability aligned with selected options */
    var productJson = $('#sn-product-json');
    var productData = null;
    try { productData = productJson ? JSON.parse(productJson.textContent) : null; } catch (e) { productData = null; }
    function syncSelectedVariant() {
      if (!productData || !productData.variants) return;
      var selected = [];
      $$('.sn-product-form__option').forEach(function (group) {
        var checked = group.querySelector('input[type="radio"]:checked');
        if (checked) selected.push(checked.value);
      });
      var variant = productData.variants.find(function (v) {
        return v.options.length === selected.length && v.options.every(function (value, index) { return value === selected[index]; });
      });
      if (!variant) return;
      var variantId = $('#sn-variant-id');
      var price = $('#sn-price');
      var atc = $('#sn-atc');
      if (variantId) variantId.value = variant.id;
      if (price) price.textContent = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(variant.price / 100);
      if (atc) {
        atc.disabled = !variant.available;
        if (!variant.available) atc.textContent = 'Sold Out';
      }
      document.dispatchEvent(new CustomEvent('sn:variant-change', { detail: variant }));
    }
    on(form, 'change', syncSelectedVariant);
    syncSelectedVariant();

    /* Add to cart feedback */
    var atcBtn = $('#sn-atc');
    on(form, 'submit', function () {
      if (!atcBtn) return;
      var paidPersonalisation = document.querySelector('input[name="sn_personalisation_choice"]:checked');
      if (paidPersonalisation && paidPersonalisation.value !== 'none') return;
      var orig = atcBtn.innerHTML;
      atcBtn.textContent = 'Adding…';
      atcBtn.disabled = true;
      setTimeout(function () {
        atcBtn.textContent = 'Added ✓';
        setTimeout(function () {
          atcBtn.innerHTML = orig;
          atcBtn.disabled = false;
        }, 1500);
      }, 700);
    });
  }

  /* ═══════════════════════════════════════
     PRODUCT IMAGE GALLERY THUMBS
  ═══════════════════════════════════════ */
  function initGalleryThumbs() {
    var mainImg = $('#sn-main-img');
    var thumbs  = $$('.sn-product-gallery__thumb');
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      on(thumb, 'click', function () {
        var src = thumb.dataset.src;
        if (!src) return;
        mainImg.style.opacity = '0';
        setTimeout(function () {
          mainImg.src = src;
          mainImg.style.opacity = '1';
        }, 180);
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  }

  /* ═══════════════════════════════════════
     PERSONALISATION ACCORDION (product page)
  ═══════════════════════════════════════ */
  function initPersonalisation() {
    var box = $('#sn-simple-personalisation');
    var form = $('#sn-product-form');
    if (!box || !form) return;
    var choices = $$('.sn-simple-option input[type="radio"]', box);
    var fields = $('[data-personalisation-fields]', box);
    var academyFields = $('[data-academy-fields]', box);
    var combined = $('[data-combined-price]', box);
    var error = $('[data-personalisation-error]', box);
    var atc = $('#sn-atc');
    var basePrice = 0;
    var selectedAvailable = true;
    var money = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });

    try {
      var initialData = JSON.parse($('#sn-product-json').textContent);
      var initialId = Number($('#sn-variant-id').value);
      var initialVariant = initialData.variants.find(function (v) { return v.id === initialId; });
      basePrice = initialVariant ? initialVariant.price : 0;
      selectedAvailable = initialVariant ? initialVariant.available : true;
    } catch (e) { basePrice = 0; }

    function choice() { return $('input[name="sn_personalisation_choice"]:checked', box); }
    function servicePrice() {
      var selected = choice();
      if (!selected || selected.value === 'none') return 0;
      return Number(selected.value === 'name' ? box.dataset.namePrice : box.dataset.academyPrice) || 0;
    }
    function refresh() {
      var selected = choice();
      var personalised = selected && selected.value !== 'none';
      var orderFormCompleted = $('#sn-order-form-completed');
      choices.forEach(function (input) { input.closest('.sn-simple-option').classList.toggle('is-selected', input.checked); });
      fields.hidden = !personalised;
      academyFields.hidden = !(selected && selected.value === 'academy');
      combined.textContent = money.format((basePrice + servicePrice()) / 100);
      if (atc) {
        atc.disabled = !selectedAvailable || (personalised && (!orderFormCompleted || !orderFormCompleted.checked));
        atc.textContent = !selectedAvailable ? 'Sold Out' : (personalised && (!orderFormCompleted || !orderFormCompleted.checked) ? 'Complete Order Form First' : 'Add to Cart');
      }
      if (error) error.hidden = true;
    }
    choices.forEach(function (input) { on(input, 'change', refresh); });
    on($('#sn-order-form-completed'), 'change', refresh);
    on(document, 'sn:variant-change', function (event) { basePrice = event.detail.price; selectedAvailable = event.detail.available; refresh(); });
    refresh();

    on(form, 'submit', function (event) {
      var selected = choice();
      if (!selected || selected.value === 'none') return;
      event.preventDefault();
      var name = $('#sn-simple-name').value.trim();
      var thread = $('#sn-simple-thread').value.trim();
      var position = $('#sn-simple-position').value;
      var academy = $('#sn-simple-academy').value.trim();
      var note = $('#sn-simple-note').value.trim();
      var terms = $('#sn-personalised-terms').checked;
      var orderFormCompleted = $('#sn-order-form-completed').checked;
      if (!orderFormCompleted || !name || !thread || !position || !terms || (selected.value === 'academy' && !academy)) {
        error.hidden = false;
        error.textContent = 'Complete and submit the S&N embroidery order form, tick the confirmation, then complete the name, thread colour, position and returns acknowledgement' + (selected.value === 'academy' ? ', plus the academy name.' : '.');
        if (atc) { atc.disabled = false; atc.textContent = 'Add to Cart'; }
        error.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        return;
      }
      var serviceVariant = selected.value === 'name' ? box.dataset.nameVariant : box.dataset.academyVariant;
      if (!serviceVariant) {
        error.hidden = false;
        error.textContent = 'This personalisation option is not available online yet. Please choose no personalisation or contact S&N.';
        if (atc) { atc.disabled = false; atc.textContent = 'Add to Cart'; }
        return;
      }
      var qty = Math.max(1, Number($('#sn-qty').value || 1));
      var properties = {
        'Personalisation': selected.value === 'name' ? 'Name embroidery' : 'Name and academy logo',
        'Exact name': name,
        'Thread colour': thread,
        'Position': position,
        'Academy': academy,
        'Customer note': note,
        'S&N embroidery form': 'Customer confirmed submitted',
        'Personalised returns acknowledgement': 'Accepted'
      };
      if (atc) { atc.disabled = true; atc.textContent = 'Adding…'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [
          { id: Number($('#sn-variant-id').value), quantity: qty, properties: properties },
          { id: Number(serviceVariant), quantity: qty, properties: { 'For product': box.dataset.productTitle || 'SN Apparel product', 'Exact name': name, 'Thread colour': thread, 'Position': position, 'Academy': academy, 'Customer note': note, 'S&N embroidery form': 'Customer confirmed submitted' } }
        ] })
      }).then(function (response) {
        if (!response.ok) throw new Error('The selected product or personalisation service is unavailable.');
        if (box.dataset.first10 === 'true' && selected.value === 'name') {
          window.location.href = '/discount/FIRST10?redirect=/cart';
        } else {
          window.location.href = '/cart';
        }
      }).catch(function (requestError) {
        error.hidden = false;
        error.textContent = requestError.message;
        if (atc) { atc.disabled = false; atc.textContent = 'Add to Cart'; }
      });
    });
  }

  /* ═══════════════════════════════════════
     CART PAGE — AJAX qty update + remove
  ═══════════════════════════════════════ */
  function initCartPage() {
    if (!$$('.sn-cart-item').length) return;

    function updateCart(key, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: key, quantity: qty })
      })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.reload(); })
      .catch(function (err) { console.error('Cart update error:', err); });
    }

    $$('.sn-cart-qty-minus').forEach(function (btn) {
      on(btn, 'click', function () {
        var key  = btn.dataset.key;
        var disp = btn.parentElement.querySelector('.sn-cart-qty-display');
        var qty  = Math.max(0, parseInt(disp.textContent, 10) - 1);
        updateCart(key, qty);
      });
    });

    $$('.sn-cart-qty-plus').forEach(function (btn) {
      on(btn, 'click', function () {
        var key  = btn.dataset.key;
        var disp = btn.parentElement.querySelector('.sn-cart-qty-display');
        var qty  = parseInt(disp.textContent, 10) + 1;
        updateCart(key, qty);
      });
    });

    $$('.sn-cart-item__remove').forEach(function (btn) {
      on(btn, 'click', function () {
        updateCart(btn.dataset.key, 0);
      });
    });
  }

})();
